module.exports = __webpack_public_path__ + "f572638f/img/attach-icon.2200b7fc.svg";